export default __webpack_public_path__ + "static/media/1839.b9606d85.png";